var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('b-spinner',{style:({ width: _vm.size, height: _vm.size }),attrs:{"variant":"hds-primary","label":"Spinning"}})
}
var staticRenderFns = []

export { render, staticRenderFns }